import styled, { css } from 'styled-components';

export default {
  H1: styled.h1`
    font-size: 40px;
    font-weight: 300;

    ${({ $bold }) =>
      $bold &&
      css`
        font-weight: 700;
      `}

    ${({ $upper }) =>
      $upper &&
      css`
        text-transform: uppercase;
      `}

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 32px;
      line-height: 32px;
    }
  `,

  H2: styled.h2`
    font-size: 32px;
    font-weight: 300;

    ${({ $bold }) =>
      $bold &&
      css`
        font-weight: 700;
      `}

    ${({ $upper }) =>
      $upper &&
      css`
        text-transform: uppercase;
      `}

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 28px;
    }
  `,

  H3: styled.h3`
    font-size: 28px;
    font-weight: 300;

    ${({ $bold }) =>
      $bold &&
      css`
        font-weight: 700;
      `}

    ${({ $upper }) =>
      $upper &&
      css`
        text-transform: uppercase;
      `}

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 24px;
    }
  `,
  H4: styled.h4`
    font-size: 24px;
    font-weight: 300;

    ${({ $bold }) =>
      $bold &&
      css`
        font-weight: 700;
      `}

    ${({ $upper }) =>
      $upper &&
      css`
        text-transform: uppercase;
      `}

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 20px;
    }
  `,

  P: styled.p`
    font-size: 20px;
    font-weight: 300;

    ${({ $bold }) =>
      $bold &&
      css`
        font-weight: 700;
      `}

    ${({ $upper }) =>
      $upper &&
      css`
        text-transform: uppercase;
      `}

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 16px;
    }
  `,

  Span: styled.span`
    font-size: 16px;
    font-weight: 300;

    ${({ $bold }) =>
      $bold &&
      css`
        font-weight: 700;
      `}

    ${({ $upper }) =>
      $upper &&
      css`
        text-transform: uppercase;
      `}

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 12px;
    }
  `,
};
